




import Vue from 'vue';

export default Vue.extend({
  name: 'Caret',
  props: {
    blink: Boolean
  }
});
